import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import './style.css';

const PrivacyPolicy = ({ isModal = false, onClose = null, children = null }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const PolicySection = ({ titleKey }) => (
    <div className="PrivacyPolicy__section">
      <h3 className="PrivacyPolicy__section-title">
        {t(`privacyPolicy.${titleKey}.title`)}
      </h3>
      <div className="PrivacyPolicy__section-content">
        {t(`privacyPolicy.${titleKey}.content`)
          .split('\n')
          .map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
      </div>
    </div>
  );

  PolicySection.propTypes = {
    titleKey: PropTypes.string.isRequired
  };

  const ModalContent = () => (
    <div className="PrivacyPolicy PrivacyPolicy--modal">
      <div className="PrivacyPolicy__modal-overlay" onClick={handleClose}>
        <div
          className="PrivacyPolicy__modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="PrivacyPolicy__modal-header">
            <h2 className="PrivacyPolicy__title">
              {t('privacyPolicy.title')}
            </h2>
            <button
              className="PrivacyPolicy__close-btn"
              onClick={handleClose}
              type="button"
              aria-label={t('common.close')}
            >
              ×
            </button>
          </div>
          <div className="PrivacyPolicy__modal-body">
            <div className="PrivacyPolicy__content">
              <h1 className="PrivacyPolicy__site-title">
                {t('privacyPolicy.siteTitle')}
              </h1>

              <p className="PrivacyPolicy__version">{t('privacyPolicy.version')}</p>

              <p className="PrivacyPolicy__intro">{t('privacyPolicy.intro')}</p>

              <PolicySection titleKey="dataController" />
              <PolicySection titleKey="dataScope" />
              <PolicySection titleKey="legalBasis" />
              <PolicySection titleKey="voluntaryData" />
              <PolicySection titleKey="dataRecipients" />
              <PolicySection titleKey="transferToThirdCountries" />
              <PolicySection titleKey="dataRetention" />
              <PolicySection titleKey="userRights" />
              <PolicySection titleKey="complaintRight" />
              <PolicySection titleKey="cookies" />
              <PolicySection titleKey="serverLogs" />
              <PolicySection titleKey="automatedDecisions" />
              <PolicySection titleKey="processor" />
              <PolicySection titleKey="policyChanges" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const InlineContent = () => (
    <div className={`PrivacyPolicy ${isExpanded ? 'PrivacyPolicy--expanded' : ''}`}>
      {!isExpanded ? (
        <button
          className="PrivacyPolicy__read-button btn--gold"
          onClick={toggleExpanded}
          type="button"
        >
          {t('privacyPolicy.readPolicy')}
        </button>
      ) : (
        <div className="PrivacyPolicy__expanded-content">
          <div className="PrivacyPolicy__content">
            <h1 className="PrivacyPolicy__site-title">
              {t('privacyPolicy.siteTitle')}
            </h1>

            <p className="PrivacyPolicy__version">{t('privacyPolicy.version')}</p>

            <p className="PrivacyPolicy__intro">{t('privacyPolicy.intro')}</p>

            <PolicySection titleKey="dataController" />
            <PolicySection titleKey="dataScope" />
            <PolicySection titleKey="legalBasis" />
            <PolicySection titleKey="voluntaryData" />
            <PolicySection titleKey="dataRecipients" />
            <PolicySection titleKey="transferToThirdCountries" />
            <PolicySection titleKey="dataRetention" />
            <PolicySection titleKey="userRights" />
            <PolicySection titleKey="complaintRight" />
            <PolicySection titleKey="cookies" />
            <PolicySection titleKey="serverLogs" />
            <PolicySection titleKey="automatedDecisions" />
            <PolicySection titleKey="processor" />
            <PolicySection titleKey="policyChanges" />
          </div>

          <button
            className="PrivacyPolicy__close-button btn--gold"
            onClick={toggleExpanded}
            type="button"
          >
            {t('common.close')}
          </button>
        </div>
      )}
      {children}
    </div>
  );

  return isModal ? <ModalContent /> : <InlineContent />;
};

PrivacyPolicy.propTypes = {
  isModal: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
};

export default PrivacyPolicy;